import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function StockMovementCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.opsMovementChart !== 'undefined') {
      window.opsMovementChart.canvas = chartRef.current;
      window.opsMovementChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title" id="opsMoveTitle">Stock Movement Trend</h3>
        <span className="click-tag">Click points to filter month</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="opsMovement" ref={chartRef}></canvas>
      </div>
    </Box>
  );
}
